export const BackgroundColors = {
  Default: "bg-white",
  Black: "bg-black",
  Gray: "bg-[#e2e2e2]",
  "Light Gray": "bg-[#F2F2F2]",
  // Wish list Oct 2026: #D4C192, and the same at 25% strength over white.
  Gold: "bg-[#D4C192]",
  "Light Gold": "bg-[#F4F0E4]",
};

export const BackgroundColorText = {
  Default: "text-black",
  Black: "text-white",
  Gray: "text-black",
  "Light Gray": "text-black",
  Gold: "text-black",
  "Light Gold": "text-black",
};

// Gold text disappears on the Gold background, so eyebrows switch to charcoal.
export const eyebrowTone = (backgroundColor?: string | null) =>
  backgroundColor === "Gold" ? "text-label--on-gold" : "";

export const BlockSplits = {
  "50-50": ["col-span-6", "col-span-6"],
  "40-60": ["col-span-5", "col-span-7"],
  "60-40": ["col-span-7", "col-span-5"],
};

export const Padding = {
  None: "py-0",
  Top: "pt-24",
  Bottom: "pb-24",
  "Top and Bottom": "py-12 lg:py-18",
  Both: "py-12 lg:py-18",
  both: "py-12 lg:py-18",
  "top and bottom": "py-12 lg:py-18",
  top: "pt-24",
  bottom: "pb-24",
  none: "py-0",
};

// Padding Top / Padding Bottom on every block. Each side is set on its own;
// an empty side falls back to the old single Padding field.
const PaddingTop = {
  None: "",
  Small: "pt-6 lg:pt-8",
  Medium: "pt-12 lg:pt-18",
  Large: "pt-18 lg:pt-24",
};

const PaddingBottom = {
  None: "",
  Small: "pb-6 lg:pb-8",
  Medium: "pb-12 lg:pb-18",
  Large: "pb-18 lg:pb-24",
};

// The old Padding values, split per side with exactly the classes they had.
const OldPaddingSides: Record<string, [string, string]> = {
  Both: [PaddingTop.Medium, PaddingBottom.Medium],
  both: [PaddingTop.Medium, PaddingBottom.Medium],
  "Top and Bottom": [PaddingTop.Medium, PaddingBottom.Medium],
  "top and bottom": [PaddingTop.Medium, PaddingBottom.Medium],
  Top: ["pt-24", ""],
  top: ["pt-24", ""],
  Bottom: ["", "pb-24"],
  bottom: ["", "pb-24"],
  None: ["", ""],
  none: ["", ""],
};

export function sectionPadding(
  block?: { padding?: string | null; paddingTop?: string | null; paddingBottom?: string | null } | null,
  fallback?: string,
): string {
  const [oldTop, oldBottom] =
    OldPaddingSides[block?.padding || fallback || "None"] ?? ["", ""];
  const top =
    PaddingTop[block?.paddingTop as keyof typeof PaddingTop] ?? oldTop;
  const bottom =
    PaddingBottom[block?.paddingBottom as keyof typeof PaddingBottom] ??
    oldBottom;
  return [top, bottom].filter(Boolean).join(" ");
}

export const CategoryMap = {
  Market: "/markets",
  Solution: "/solutions",
  Product: "/products",
  "Case Study": "/case-studies",
  Series: "/series",
  Training: "/training",
  Category: "/categories",
};

// "Table Style" (Text Block, Split Block) → class on the text wrapper (see global.scss)
export const TableStyles = {
  "Key / Value": "table-lines table-key-value",
  Lines: "table-lines",
};

export function tableStyleClass(style?: string | null): string {
  return TableStyles[style as keyof typeof TableStyles] || "";
}
